import { Component, HostBinding, Input, inject } from '@angular/core';
import {fadeInOnEnterAnimation} from 'angular-animations';
import {timer} from "rxjs";
import {TimeService} from "@shared";


@Component({
    selector: 'app-route-key-number',
    templateUrl: './route-key-number.component.html',
    styleUrls: ['./route-key-number.component.scss'],
    animations: [fadeInOnEnterAnimation({ duration: 500 })],
    standalone: false
})
export class RouteKeyNumberComponent {
    private readonly timeService = inject(TimeService);

    @Input() public printView: boolean;
    @Input() public pdfViewTranslation: string;
    @Input() public translation: string;
    @Input() public tooltip: string;
    @Input() public textParam: unknown;
    @Input() public whiteBackground: boolean;
    @Input() public inverseColor: boolean;

    @Input()
    public set compareValue(value: number) {
        if (value !== undefined) {
            this.hasLoaded = true;
            if (value) {
                if (this.previousValue !== undefined) {

                        if (value > this.previousValue) {
                            this.inverseColor ? this.increase = false : this.increase = true;
                        } else if (value < this.previousValue) {
                            this.inverseColor ? this.increase = true : this.increase = false;
                        } else {
                            this.increase = null;
                        }
                    

                    const updateTimer = timer(3000);
                    const timerSubscription = updateTimer.subscribe(() => {
                        this.increase = null;
                        timerSubscription.unsubscribe();
                    });
                }
                this.previousValue = value;
            } else {
                this.increase = null;
            }
        }
    }

    public reset(): void {
        this.previousValue = undefined;
    }

    @HostBinding('class') loadingClass = 'loading';
    public increase: boolean;
    public hasLoaded: boolean;
    private previousValue: number;
}
